import { io } from 'socket.io-client';
import { apiUrl } from '../pages/UrlParam';

//const socket = io(apiUrl);  
const socket =''
export default socket;